// src/state/menu/types/menuType_types.ts
var ECoursingType = /* @__PURE__ */ ((ECoursingType2) => {
  ECoursingType2["COURSING"] = "coursing";
  ECoursingType2["ROUNDING"] = "rounding";
  ECoursingType2["NONE"] = "none";
  return ECoursingType2;
})(ECoursingType || {});

export { ECoursingType };
